// src/components/Auth/AuthHeader.jsx
import React from "react";
import {Image} from "antd";
import logo from "./icons/DiffuzLogoPurple.svg"

const AuthHeader = ({
                        active = "signup",
                        onSignupClick,
                        onLoginClick,
                        signupText = "Sign up",
                        loginText = "Log in",
                        logoSrc = logo,
                    }) => {
    const isSignup = active === "signup";

    const base =
        "rounded-full min-w-24 h-9 w-full border-0 whitespace-nowrap transition-colors text-base";

    const activeTab = "bg-[#1b152b] text-white";
    const inactiveTab = "bg-[#c7a0f9] text-white";

    const signupClass = `${base} ${isSignup ? activeTab : inactiveTab}`;
    const loginClass = `${base} ${!isSignup ? activeTab : inactiveTab}`;

    return (
        <div className="flex flex-col items-center gap-4">
            <img
                src={logoSrc}
                width={120}
                height={120}
                alt="Diffuzio logo"
                className="select-none"
                draggable="false"
            />
            <div className="grid grid-cols-2 gap-5 w-full max-w-[320px]">

            </div>
        </div>
    );
};

export default AuthHeader

